export const SectionHeading = ({ eyebrow, title, children, id }) => (
  <div className="gg-section-heading" data-testid={`${id}-heading`}>
    <p className="gg-eyebrow">{eyebrow}</p>
    <h2>{title}</h2>
    {children && <p className="gg-section-intro">{children}</p>}
  </div>
);